module.exports = {"attributes":{"viewBox":"0 0 14 14"},"content":"<defs>     <path id=\"a\" d=\"M0 0h14v14H0z\"/>   </defs>   <g fill=\"none\" fill-rule=\"evenodd\">     <mask id=\"b\" fill=\"#fff\">       <use xlink:href=\"#a\"/>     </mask>     <path fill=\"#0F88EB\" d=\"M9.8 4.3v1.4H7.7v1h2V8h-2v1H6.3v-1h-2V6.7h2v-1h-2V4.3H5L3.7 3l1-1L7 4.3 9.3 2l1 1L9 4.3h.8zM12.6 0H1.4C.6 0 0 .6 0 1.4V14l2.8-2.8h9.8c.8 0 1.4-.6 1.4-1.4V1.4c0-.8-.6-1.4-1.4-1.4z\" mask=\"url(#b)\"/>   </g>"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-currency.svg
// module id = 618
// module chunks = 0